<template>
  <div id="modalAccount" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Minha Conta</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="updateUserPassword">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label">
                  Senha Antiga: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.antigaSenha.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.antigaSenha.$model"
                />
                <span
                  v-if="
                    v$.antigaSenha.minLength.$invalid &&
                    v$.antigaSenha.$errors.length
                  "
                  class="invalid-feedback"
                >
                  A senha deve ter pelo menos
                  {{ v$.antigaSenha.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-12">
                <label class="form-label">
                  Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.senha.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.senha.$model"
                />
                <span
                  v-if="v$.senha.required.$invalid && v$.senha.$errors.length"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.senha.minLength.$invalid && v$.senha.$errors.length"
                  class="invalid-feedback"
                >
                  A senha deve ter pelo menos
                  {{ v$.senha.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-12">
                <label class="form-label">
                  Confirme a Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.confirmaSenha.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.confirmaSenha.$model"
                />
                <span
                  v-if="
                    v$.confirmaSenha.sameAsPassword.$invalid &&
                    v$.confirmaSenha.$errors.length
                  "
                  class="invalid-feedback"
                >
                  As senhas devem ser idênticas
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-dark"
              title="Atualizar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Atualizar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import { mapGetters } from 'vuex'

export default {
  name: 'AccountModal',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      antigaSenha: '',
      senha: '',
      confirmaSenha: '',
      disableButton: false,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    async updateUserPassword() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch('updateUserPassword', {
            id: this.user.id,
            antigaSenha: this.antigaSenha,
            senha: this.senha,
            confirmaSenha: this.confirmaSenha,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      antigaSenha: {
        required,
        minLength: minLength(6),
      },
      senha: {
        required,
        minLength: minLength(6),
      },
      confirmaSenha: {
        sameAsPassword: sameAs(this.senha),
      },
    }
  },

  mounted() {
    showModal('modalAccount')
  },
}
</script>
